/* Publish by EComposer at 2026-10-03 17:32:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8p5027rtlww"]=  window.__ectimmers["ecom-8p5027rtlww"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8p5027rtlww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8p5027rtlww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4abuf26bx8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4abuf26bx8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjtqhkkj47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjtqhkkj47', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clwks9vmbee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clwks9vmbee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7jm2ilodj4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7jm2ilodj4p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l16isjp2xie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l16isjp2xie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-loc5doza6hc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-loc5doza6hc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r44hahhpg2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r44hahhpg2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tn3rmxdh49').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tn3rmxdh49', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t785san9m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t785san9m4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8f4oheyiwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8f4oheyiwf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r56jycf5nx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r56jycf5nx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvdcnltrkqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvdcnltrkqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nx1dg38mqbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nx1dg38mqbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0v2xjhv6z6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0v2xjhv6z6p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi5xbta9bxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi5xbta9bxf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oc2eg8oaogl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oc2eg8oaogl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yejfzuaan').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yejfzuaan', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqf4y4dcy7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqf4y4dcy7e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pf6mdl18aoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pf6mdl18aoe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pg7iartomy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pg7iartomy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d1ujq5enloo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d1ujq5enloo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uk39i5zytdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uk39i5zytdd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-esx357p4gyj"]=  window.__ectimmers["ecom-esx357p4gyj"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;function n(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var m;(m=d.ec_splide)==null||m.refresh()})},50),r())}e.forEach((a,l)=>{o==="click"||window.screen.width<1025?a.onclick=()=>n(a,l):a.onmouseover=()=>n(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let g=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,g)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-esx357p4gyj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esx357p4gyj', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}